import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { QueryOptions, useQuery } from '@globalconnect/query';
import {
  ConstructionDocumentsGetFileResponse,
  ConstructionDocumentsResponse,
} from '../entities/construction-documents-entities';
import { constructionDocumentsKey } from '../entities/query-keys';
import { ConstructionDocumentsApiService } from './construction-documents-api.service';

@Injectable({
  providedIn: 'root',
})
export class ConstructionDocumentsService {
  private readonly _modalState = signal(false);
  readonly modalState = this._modalState.asReadonly();

  constructor(
    private constructionDocumentsApiService: ConstructionDocumentsApiService,
  ) {}

  getPUBLFolder$(
    ifsNumber: string,
    options?: Partial<
      QueryOptions<
        ConstructionDocumentsResponse,
        HttpErrorResponse,
        never,
        ConstructionDocumentsResponse
      >
    >,
  ) {
    return useQuery(
      [constructionDocumentsKey, ifsNumber],
      () => this.constructionDocumentsApiService.getFolder$(ifsNumber),
      { ...options },
    ).getState$();
  }

  getFolderFromPath$(
    ifsNumber: string,
    path: string,
    options?: Partial<
      QueryOptions<
        ConstructionDocumentsResponse,
        HttpErrorResponse,
        never,
        ConstructionDocumentsResponse
      >
    >,
  ) {
    return useQuery(
      [constructionDocumentsKey, ifsNumber + '-' + path],
      () =>
        this.constructionDocumentsApiService.getFolder$(
          `${ifsNumber}?path=${path}`,
        ),
      { ...options },
    ).getState$();
  }

  getFile$(
    ifsNumber: string,
    itemId: string,
    options?: Partial<
      QueryOptions<
        ConstructionDocumentsGetFileResponse,
        HttpErrorResponse,
        never,
        ConstructionDocumentsGetFileResponse
      >
    >,
  ) {
    return useQuery(
      [constructionDocumentsKey, ifsNumber + '-' + itemId],
      () => this.constructionDocumentsApiService.getFile$(ifsNumber, itemId),
      { ...options },
    ).getState$();
  }

  setModalState = (state: boolean) => {
    this._modalState.set(state);
  };
}
